import { render, staticRenderFns } from "./ST120CreationModal.vue?vue&type=template&id=50df3dd4&scoped=true&"
import script from "./ST120CreationModal.vue?vue&type=script&lang=ts&"
export * from "./ST120CreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df3dd4",
  null
  
)

export default component.exports